// Function to process badges
const processBadges = () => {
  document.querySelectorAll('.plp-card').forEach(card => {
    const badge = card.querySelector('.absolute.top-0.right-0.bg-grey-900');
    if (!badge || badge.classList.contains('percent-processed')) return;

    const originalPrice = card.querySelector('.plp-card-price .line-through');
    const salePrice = card.querySelector('.plp-card-price > span:not(.line-through)');
    if (!originalPrice || !salePrice) return;

    const badgeText = badge.querySelector('span');
    if (!badgeText) return;

    const original = parseFloat(originalPrice.textContent.replace('$', ''));
    const sale = parseFloat(salePrice.textContent.replace('$', ''));
    if (original > 0 && sale > 0 && original > sale) {
      const percentOff = Math.round(((original - sale) / original) * 100);

      // Hide existing badge text
      badgeText.style.display = 'none';

      // Add our own span only if it doesn't exist
      if (!badge.querySelector('.percent-off')) {
        const newSpan = document.createElement('span');
        newSpan.className = 'percent-off p-2 text-xs font-medium text-black uppercase';
        newSpan.textContent = `${percentOff}% OFF`;
        badge.appendChild(newSpan);
      }

      badge.classList.add('percent-processed');
      badge.style.opacity = 1; // ensure badge is visible
    }
  });
};

// Initial run
processBadges();

// Observe DOM changes (e.g., lazy loading)
let timeout;
const observer = new MutationObserver(() => {
  clearTimeout(timeout);
  timeout = setTimeout(processBadges, 100);
});
observer.observe(document.body, { childList: true, subtree: true });